// Common constants used across the application
export const BATCH_YEARS = [
  { label: "2024 - 2026", value: "2024-2026" },
  { label: "2025 - 2026", value: "2025-2026" },
  { label: "2025 - 2027", value: "2025-2027" },
];


export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Others", label: "Others" },
];

// Question types as they come from the `assessment_sections` table.
export const TYPE = {
  SINGLE_CHOICE: "single_choice",
  MULTIPLE_CHOICE: "multiple_choice",
  RATING: "rating",
  OPEN_TEXT: "open_text",
};